<div class="portal-page-content">
  @if (loading) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  } @else {
    <div fxLayout="row" fxLayout.lt-md="column" class="credentials-heading">
      <div fxFlex>
        <h2 class="header m-0">
          Credentials
          <span class="header-summary"
            ><mat-icon>verified</mat-icon>{{ activeCredentialCount }} active
            {{
              activeCredentialCount === 1 ? 'credential' : 'credentials'
            }}</span
          >
        </h2>
      </div>
    </div>

    <div class="in-progress-header">
      <h3>In Progress Applications</h3>
    </div>
    @if (!applications || applications.length === 0) {
      <div class="no-items">There are no in progress applications.</div>
    }
    @for (application of applications; track application.id) {
      <credential-application-card
        [application]="application"
      ></credential-application-card>
    }

    <h3>Credentials</h3>
    @if (!credentials || credentials.length === 0) {
      <div class="no-items">There are no credentials.</div>
    }
    @for (credential of credentials; track credential.id) {
      <credential-snapshot class="credential-item" [credential]="credential">
      </credential-snapshot>
    }
  }
</div>
